"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var RenderIf_1 = __importDefault(require("../../RenderIf"));
var VideoPlayerIds_1 = __importDefault(require("../../../VideoPlayerIds"));
var VideoButtonVolume_1 = __importDefault(require("../styles/VideoButtonVolume"));
var VideoInputVolumeRange_1 = __importDefault(require("../styles/VideoInputVolumeRange"));
var ButtonVolumeFullSvg_1 = __importDefault(require("../assets/ButtonVolumeFullSvg"));
var ButtonVolumeHalfSvg_1 = __importDefault(require("../assets/ButtonVolumeHalfSvg"));
var ButtonVolumeOffSvg_1 = __importDefault(require("../assets/ButtonVolumeOffSvg"));
var VideoButtonVolume = function (_a) {
    var _b;
    var controller = _a.controller, volumeLevel = _a.volumeLevel;
    var _c = react_1.useState(false), isMuted = _c[0], setIsMuted = _c[1];
    var _d = react_1.useState(0), valueVolumeRange = _d[0], setValueVolumeRange = _d[1];
    react_1.useEffect(function () {
        var _a;
        setIsMuted((_a = controller === null || controller === void 0 ? void 0 : controller.video) === null || _a === void 0 ? void 0 : _a.muted);
    }, [(_b = controller === null || controller === void 0 ? void 0 : controller.video) === null || _b === void 0 ? void 0 : _b.muted]);
    react_1.useEffect(function () {
        setValueVolumeRange(Number(controller === null || controller === void 0 ? void 0 : controller.inputVolumeRange.value) || 0);
    }, [controller === null || controller === void 0 ? void 0 : controller.inputVolumeRange.value]);
    var handleButtonVolumeClick = function (event) {
        controller === null || controller === void 0 ? void 0 : controller.handleButtonVolumeClick(event);
    };
    return (jsx_runtime_1.jsxs(VideoButtonVolume_1.default, __assign({ id: VideoPlayerIds_1.default.ButtonVolume }, { children: [jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: valueVolumeRange === 0 || isMuted }, { children: jsx_runtime_1.jsx(ButtonVolumeOffSvg_1.default, { onClick: handleButtonVolumeClick }, void 0) }), void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: !isMuted && valueVolumeRange <= 50 && valueVolumeRange > 0 }, { children: jsx_runtime_1.jsx(ButtonVolumeHalfSvg_1.default, { onClick: handleButtonVolumeClick }, void 0) }), void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: !isMuted && valueVolumeRange > 50 }, { children: jsx_runtime_1.jsx(ButtonVolumeFullSvg_1.default, { onClick: handleButtonVolumeClick }, void 0) }), void 0), jsx_runtime_1.jsx(VideoInputVolumeRange_1.default, { id: VideoPlayerIds_1.default.InputVolumeRange, type: "range", min: 0, max: 100, defaultValue: 100, onChange: controller === null || controller === void 0 ? void 0 : controller.handleInputVolumeRangeChange }, void 0)] }), void 0));
};
exports.default = VideoButtonVolume;
